import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { map } from 'lodash';

import KTabs from '../KJRN/KTabs';
import KTab from '../KJRN/KTab';
import EmployeeCompanyConnectionTable from './EmployeeCompanyConnectionTable';

const EmployeeCompanyConnectionsTabs = ({ employeeDetailOrgList, language, valuesByKey }) => (
  <KTabs>
    {map(employeeDetailOrgList, (obj, i) => (
      <KTab style={{ padding: 12 }} key={i} name={obj.OrgCompanyPositionName}>
        <EmployeeCompanyConnectionTable
          employeeCompanyConnection={obj}
          valuesByKey={valuesByKey}
          language={language}
        />
      </KTab>
  ))}
  </KTabs>
);

EmployeeCompanyConnectionsTabs.propTypes = {
  employeeDetailOrgList: PropTypes.array.isRequired,
  valuesByKey: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
};

const mapStateToProps = ({ languageReducer, profileReducer, WebValuesReducer }) => ({
  language: languageReducer.language,
  valuesByKey: WebValuesReducer.valuesByKey,
  employeeDetailOrgList: profileReducer.employeeDetailOrgList,
});

export default connect(mapStateToProps)(EmployeeCompanyConnectionsTabs);



// WEBPACK FOOTER //
// ./src/components/profile/EmployeeCompanyConnectionsTabs.js